export const Slash = () => <>&#47;</>;
export const Dash = () => <>&mdash;</>;
